import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
const paneW = 1000;
export default class TabPane extends Component {
  static propTypes = {
    defaultActiveKey: PropTypes.number.isRequired,
  };
  componentDidMount() {
    const { defaultActiveKey } = this.props;
    this.movePane(defaultActiveKey);
  }
  componentDidUpdate() {
    const { defaultActiveKey } = this.props;
    this.movePane(defaultActiveKey);
  }
  movePane(activeKey) {
    let pane = ReactDOM.findDOMNode(this.refs.pane);
    pane.style.transform = `translateX(${-activeKey * 1000}px)`;
    pane.style.WebkitTransform = `translateX(${-activeKey * 1000}px)`;
  }
  render() {
    const { defaultActiveKey } = this.props;
    let children = [];
    for (let i = 0; i < this.props.children.length; i++) {
      const child = this.props.children[i];
      if (defaultActiveKey === i) {
        children.push(child);
      } else {
        children.push(<div key={i} style={{ width: paneW }}></div>)
      }
    }
    return (
      <div className="center-tab-pane">
        <div className="center-tab-pane-inner" style={{ width: this.props.children.length * paneW }} ref="pane">
          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/center/TabPane.js